import axios from 'axios';

export default {
  addToWaitlist,
  getWaitlists
};

export function addToWaitlist(params) {
  return axios.post('/api/waitlist/addToWaitlist', params);
}

export function getWaitlists() {
  return axios.get('/api/waitlist/getWaitlists');
}
